<script lang="ts" module>
  export const definitionModal = new ModalQueryState('definition');
</script>

<script lang="ts">
  import Close from '~icons/mdi/close';
  import ActionButton from '../components/ActionButton.svelte';
  import Modal from '../components/Modal.svelte';
  import Report from '../modals/Report.svelte';
  import Pronunciation from './Pronunciation.svelte';
  import Spinner from '../components/Spinner.svelte';
  import { slide } from 'svelte/transition';
  import { lookupWordQuery } from '~/lib/queries.svelte';
  import { ModalQueryState } from '~/lib/nav.svelte';

  const word = $derived(definitionModal.value);

  const lookupWord = $derived(lookupWordQuery(word));

  const handleClose = () => {
    definitionModal.pop();
  };
</script>

<Modal open={definitionModal.open} index={5} onClose={handleClose}>
  {#snippet title()}
    {word}
  {/snippet}
  {#snippet content()}
    {#if lookupWord.isLoading}
      <div transition:slide>
        <Spinner />
      </div>
    {:else if lookupWord.data}
      <div transition:slide>
        <div class="pronunciation-row">
          {#if lookupWord.data.phonetic}
            <h2>{lookupWord.data.phonetic}</h2>
          {/if}
          {#if word}
            <Pronunciation {word} />
          {/if}
        </div>
        {#each lookupWord.data.meanings as meaning}
          <h3>{meaning.partOfSpeech}</h3>
          <div class="definitions">
            {#each meaning.definitions as definition}
              <p>
                {definition.definition}
              </p>
            {/each}
          </div>
        {/each}
        <div>
          Provided by <a href={lookupWord.data.sourceUrl}>Wiktionary</a>
        </div>
      </div>
    {:else}
      no definitions found
    {/if}
  {/snippet}
  {#snippet controls()}
    <ActionButton onClick={handleClose}>
      <Close />
      Close
    </ActionButton>
    {#if word}
      <Report {word} />
    {/if}
  {/snippet}
</Modal>

<style lang="scss">
  .definitions {
    width: 100%;
  }
  .pronunciation-row {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 4px 12px;
    width: 100%;
    h2 {
      margin: 0;
    }
  }
  p {
    border-left: 4px solid grey;
    padding-left: 8px;
    text-align: left;
    font-weight: 500;
    opacity: 90%;
  }
</style>
